import { render, staticRenderFns } from "./PhotoComponent.vue?vue&type=template&id=31a20d90"
import script from "./PhotoComponent.vue?vue&type=script&lang=js"
export * from "./PhotoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports